import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    const options = {
        params: params,
        paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
        }
    };

    return axios.get(`${url}/cash_registers?include=device`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/cash_registers/${id}?include=endUser,fiscalizationRequests,device,vatRates,headers,location`, options)
        .then(response => {
            let cashRegister = jsona.deserialize(response.data);
            delete cashRegister.links;
            return cashRegister;
        });
}

function add(cashRegister) {
    const payload = jsona.serialize({
        stuff: cashRegister,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/cash_registers`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function generateToken(location_id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/register-device/generate-token/${location_id}`, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function getToken() {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/register-device/get-token`, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update(cashRegister) {
    const payload = jsona.serialize({
        stuff: cashRegister,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/cash_registers/${cashRegister.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function updateLocation(cashRegister) {
    const payload = jsona.serialize({
        stuff: cashRegister,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/cash-registers/${cashRegister.id}/update-location`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/cash_registers/${id}`, options);
}

function listFromLocation(params) {
    const locationId = params.locationId;
    const options = {
        params: params,
        paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
        }
    };
    delete options.params.locationId;

    return axios.get(`${url}/locations/${locationId}/cashRegisters?include=device`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

export default {
    list,
    get,
    add,
    generateToken,
    getToken,
    update,
    updateLocation,
    destroy,
    listFromLocation,
};